// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h_kos_page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Header ── */
.h_kos_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding-top: 6px;
  flex-wrap: wrap;
}

.h_kos_header-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.h_kos_header-icon {
  width: 26px;
  height: 26px;
  color: #0860e6;
  flex-shrink: 0;
}

.h_kos_title {
  font-size: 22px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0;
}

.h_kos_subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
  max-width: 480px;
}

.h_kos_header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding-top: 6px;
  flex-wrap: wrap;
}

.h_kos_filter-btn-wrapper {
  position: relative;
  display: inline-flex;
}

.h_kos_filter-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  background: #1976d2;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  pointer-events: none;
}

/* ── Controls Row (Tabs + Period) ── */
.h_kos_controls-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

/* ── Tabs ── */
.h_kos_tabs {
  display: flex;
  gap: 4px;
  background: #f0f0f0;
  border-radius: 8px;
  padding: 4px;
  overflow-x: auto;
  flex-shrink: 0;
}

.h_kos_tab {
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
  color: #6b6b6b;
  transition: background 0.15s, color 0.15s;
  font-family: inherit;
  white-space: nowrap;
}

.h_kos_tab-active {
  background: #ffffff;
  color: #0b0b0b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* ── Period Selector ── */
.h_kos_period-group {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f0f0f0;
  border-radius: 8px;
  padding: 4px;
  flex-shrink: 0;
}

.h_kos_period-btn {
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
  color: #6b6b6b;
  transition: background 0.15s, color 0.15s;
  font-family: inherit;
  white-space: nowrap;
}

.h_kos_period-active {
  background: #ffffff;
  color: #0b0b0b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* ── Table ── */
.h_kos_table-card {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  overflow: hidden;
}

.h_kos_table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.h_kos_no-results {
  font-size: 13px;
  color: #6b6b6b;
  padding: 40px 20px;
  text-align: center;
  margin: 0;
}

/* ── Cell helpers ── */
.h_kos_datetime-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.h_kos_date {
  font-size: 13px;
  font-weight: 500;
  color: #0b0b0b;
  white-space: nowrap;
}

.h_kos_time {
  font-size: 13px;
  color: #6b6b6b;
  white-space: nowrap;
}

.h_kos_description {
  font-size: 13px;
  color: #0b0b0b;
  line-height: 1.4;
}

.h_kos_outlet-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #0b0b0b;
  white-space: nowrap;
}

.h_kos_outlet-icon {
  width: 15px;
  height: 15px;
  color: #6b6b6b;
  flex-shrink: 0;
}

.h_kos_user {
  font-size: 13px;
  color: #4b4b4b;
  white-space: nowrap;
}

.h_kos_amount {
  font-size: 13px;
  font-weight: 500;
  color: #0b0b0b;
  white-space: nowrap;
}

/* ── Event Type Badges ── */
.h_kos_type-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #d0d0d0;
  white-space: nowrap;
}

.h_kos_type-dispatch    { border-color: #c0cfe8; color: #1a52a8; background: #f0f5ff; }
.h_kos_type-prep        { border-color: #c8d8c8; color: #2a6a3a; background: #f0faf0; }
.h_kos_type-inventory   { border-color: #e8d8b8; color: #9a6a0a; background: #fffaf0; }
.h_kos_type-recon       { border-color: #d8c8e8; color: #6a2a9a; background: #f8f0ff; }

/* ── Status Badges ── */
.h_kos_status-badge {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.h_kos_status-completed { background: #e6f7ed; color: #219647; }
.h_kos_status-pending   { background: #f0f0f0; color: #6b6b6b; }
.h_kos_status-flagged   { background: #ffe9e9; color: #e90000; }
.h_kos_status-approved  { background: #e6f7ed; color: #219647; }
.h_kos_status-partial   { background: #fff3e0; color: #e07a00; }
.h_kos_status-rejected  { background: #ffe9e9; color: #e90000; }

/* ── Toolbar ── */
.h_kos_toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.h_kos_search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 380px;
  min-width: 200px;
}

.h_kos_search-icon {
  position: absolute;
  left: 10px;
  width: 16px;
  height: 16px;
  color: #9b9b9b;
  pointer-events: none;
}

.h_kos_search {
  width: 100%;
  padding: 8px 12px 8px 34px;
  font-size: 13px;
  color: #0b0b0b;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  background: #fff;
  outline: none;
  font-family: inherit;
  transition: border-color 0.15s;
}

.h_kos_search:focus {
  border-color: #0860e6;
}

.h_kos_search::placeholder {
  color: #9b9b9b;
}

.h_kos_toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

/* ── Date picker button ── */
.h_kos_date-btn-wrapper {
  position: relative;
}

.h_kos_date-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #0b0b0b;
  background: #fff;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: border-color 0.15s;
}

.h_kos_date-btn:hover {
  border-color: #0860e6;
}

.h_kos_date-icon {
  width: 16px;
  height: 16px;
  color: #6b6b6b;
  flex-shrink: 0;
}

.h_kos_date-popup {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 200;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.h_kos_date-popup-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid #f0f0f0;
}

.h_kos_date-clear {
  background: none;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #e90000;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;
}

.h_kos_date-clear:hover {
  background: #ffe9e9;
}

.h_kos_date-ok {
  background: #0860e6;
  border: none;
  border-radius: 6px;
  padding: 5px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;
}

.h_kos_date-ok:hover {
  background: #064fc0;
}

/* ── Request ID link ── */
.h_kos_id-link {
  color: #0860e6;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.h_kos_id-link:hover {
  text-decoration: underline;
}

/* ── Action link ── */
.h_kos_action-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  color: #0860e6;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
  white-space: nowrap;
}

.h_kos_action-link:hover {
  text-decoration: underline;
}

.h_kos_action-icon {
  width: 15px;
  height: 15px;
}

/* ── Responsive ──────────────────────────────────────────────────────────────── */

@media (max-width: 900px) {
  .h_kos_header {
    flex-direction: column;
    align-items: flex-start;
  }

  .h_kos_header-actions {
    padding-top: 0;
    width: 100%;
    justify-content: flex-end;
  }

  .h_kos_title {
    font-size: 18px;
  }

  .h_kos_controls-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .h_kos_period-group {
    width: 100%;
    justify-content: flex-start;
  }

  .h_kos_toolbar {
    flex-direction: column;
    align-items: flex-start;
  }

  .h_kos_search-wrapper {
    max-width: 100%;
    width: 100%;
  }

  .h_kos_toolbar-right {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 640px) {
  .h_kos_tabs {
    width: 100%;
  }

  .h_kos_tab {
    padding: 7px 12px;
  }

  .h_kos_period-btn {
    padding: 6px 10px;
  }

  .h_kos_date-popup {
    right: auto;
    left: 0;
  }
}

@media (max-width: 480px) {
  .h_kos_title {
    font-size: 16px;
  }

  .h_kos_subtitle {
    max-width: 100%;
  }

  .h_kos_header-actions {
    gap: 6px;
  }

  .h_kos_date-btn {
    font-size: 12px;
    padding: 6px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Kitchen-OS/components/history-kitchenOS.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,0BAA0B,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACtF,0BAA0B,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACtF,0BAA0B,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACtF,0BAA0B,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAEtF,wBAAwB;AACxB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;;AAE/D,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mFAAmF;;AAEnF;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,OAAO;EACT;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".h_kos_page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Header ── */\n.h_kos_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  padding-top: 6px;\n  flex-wrap: wrap;\n}\n\n.h_kos_header-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.h_kos_header-icon {\n  width: 26px;\n  height: 26px;\n  color: #0860e6;\n  flex-shrink: 0;\n}\n\n.h_kos_title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0;\n}\n\n.h_kos_subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n  max-width: 480px;\n}\n\n.h_kos_header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  padding-top: 6px;\n  flex-wrap: wrap;\n}\n\n.h_kos_filter-btn-wrapper {\n  position: relative;\n  display: inline-flex;\n}\n\n.h_kos_filter-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 18px;\n  height: 18px;\n  background: #1976d2;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  pointer-events: none;\n}\n\n/* ── Controls Row (Tabs + Period) ── */\n.h_kos_controls-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n/* ── Tabs ── */\n.h_kos_tabs {\n  display: flex;\n  gap: 4px;\n  background: #f0f0f0;\n  border-radius: 8px;\n  padding: 4px;\n  overflow-x: auto;\n  flex-shrink: 0;\n}\n\n.h_kos_tab {\n  padding: 7px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  background: transparent;\n  color: #6b6b6b;\n  transition: background 0.15s, color 0.15s;\n  font-family: inherit;\n  white-space: nowrap;\n}\n\n.h_kos_tab-active {\n  background: #ffffff;\n  color: #0b0b0b;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* ── Period Selector ── */\n.h_kos_period-group {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: #f0f0f0;\n  border-radius: 8px;\n  padding: 4px;\n  flex-shrink: 0;\n}\n\n.h_kos_period-btn {\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  background: transparent;\n  color: #6b6b6b;\n  transition: background 0.15s, color 0.15s;\n  font-family: inherit;\n  white-space: nowrap;\n}\n\n.h_kos_period-active {\n  background: #ffffff;\n  color: #0b0b0b;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* ── Table ── */\n.h_kos_table-card {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.h_kos_table-scroll {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.h_kos_no-results {\n  font-size: 13px;\n  color: #6b6b6b;\n  padding: 40px 20px;\n  text-align: center;\n  margin: 0;\n}\n\n/* ── Cell helpers ── */\n.h_kos_datetime-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.h_kos_date {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0b0b0b;\n  white-space: nowrap;\n}\n\n.h_kos_time {\n  font-size: 13px;\n  color: #6b6b6b;\n  white-space: nowrap;\n}\n\n.h_kos_description {\n  font-size: 13px;\n  color: #0b0b0b;\n  line-height: 1.4;\n}\n\n.h_kos_outlet-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #0b0b0b;\n  white-space: nowrap;\n}\n\n.h_kos_outlet-icon {\n  width: 15px;\n  height: 15px;\n  color: #6b6b6b;\n  flex-shrink: 0;\n}\n\n.h_kos_user {\n  font-size: 13px;\n  color: #4b4b4b;\n  white-space: nowrap;\n}\n\n.h_kos_amount {\n  font-size: 13px;\n  font-weight: 500;\n  color: #0b0b0b;\n  white-space: nowrap;\n}\n\n/* ── Event Type Badges ── */\n.h_kos_type-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  border: 1px solid #d0d0d0;\n  white-space: nowrap;\n}\n\n.h_kos_type-dispatch    { border-color: #c0cfe8; color: #1a52a8; background: #f0f5ff; }\n.h_kos_type-prep        { border-color: #c8d8c8; color: #2a6a3a; background: #f0faf0; }\n.h_kos_type-inventory   { border-color: #e8d8b8; color: #9a6a0a; background: #fffaf0; }\n.h_kos_type-recon       { border-color: #d8c8e8; color: #6a2a9a; background: #f8f0ff; }\n\n/* ── Status Badges ── */\n.h_kos_status-badge {\n  display: inline-block;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.h_kos_status-completed { background: #e6f7ed; color: #219647; }\n.h_kos_status-pending   { background: #f0f0f0; color: #6b6b6b; }\n.h_kos_status-flagged   { background: #ffe9e9; color: #e90000; }\n.h_kos_status-approved  { background: #e6f7ed; color: #219647; }\n.h_kos_status-partial   { background: #fff3e0; color: #e07a00; }\n.h_kos_status-rejected  { background: #ffe9e9; color: #e90000; }\n\n/* ── Toolbar ── */\n.h_kos_toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.h_kos_search-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  max-width: 380px;\n  min-width: 200px;\n}\n\n.h_kos_search-icon {\n  position: absolute;\n  left: 10px;\n  width: 16px;\n  height: 16px;\n  color: #9b9b9b;\n  pointer-events: none;\n}\n\n.h_kos_search {\n  width: 100%;\n  padding: 8px 12px 8px 34px;\n  font-size: 13px;\n  color: #0b0b0b;\n  border: 1px solid #d8d8d8;\n  border-radius: 8px;\n  background: #fff;\n  outline: none;\n  font-family: inherit;\n  transition: border-color 0.15s;\n}\n\n.h_kos_search:focus {\n  border-color: #0860e6;\n}\n\n.h_kos_search::placeholder {\n  color: #9b9b9b;\n}\n\n.h_kos_toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n/* ── Date picker button ── */\n.h_kos_date-btn-wrapper {\n  position: relative;\n}\n\n.h_kos_date-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0b0b0b;\n  background: #fff;\n  border: 1px solid #d8d8d8;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n  transition: border-color 0.15s;\n}\n\n.h_kos_date-btn:hover {\n  border-color: #0860e6;\n}\n\n.h_kos_date-icon {\n  width: 16px;\n  height: 16px;\n  color: #6b6b6b;\n  flex-shrink: 0;\n}\n\n.h_kos_date-popup {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 6px);\n  z-index: 200;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n}\n\n.h_kos_date-popup-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.h_kos_date-clear {\n  background: none;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 5px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #e90000;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s;\n}\n\n.h_kos_date-clear:hover {\n  background: #ffe9e9;\n}\n\n.h_kos_date-ok {\n  background: #0860e6;\n  border: none;\n  border-radius: 6px;\n  padding: 5px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s;\n}\n\n.h_kos_date-ok:hover {\n  background: #064fc0;\n}\n\n/* ── Request ID link ── */\n.h_kos_id-link {\n  color: #0860e6;\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.h_kos_id-link:hover {\n  text-decoration: underline;\n}\n\n/* ── Action link ── */\n.h_kos_action-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: none;\n  border: none;\n  color: #0860e6;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0;\n  font-family: inherit;\n  white-space: nowrap;\n}\n\n.h_kos_action-link:hover {\n  text-decoration: underline;\n}\n\n.h_kos_action-icon {\n  width: 15px;\n  height: 15px;\n}\n\n/* ── Responsive ──────────────────────────────────────────────────────────────── */\n\n@media (max-width: 900px) {\n  .h_kos_header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .h_kos_header-actions {\n    padding-top: 0;\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .h_kos_title {\n    font-size: 18px;\n  }\n\n  .h_kos_controls-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .h_kos_period-group {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .h_kos_toolbar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .h_kos_search-wrapper {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .h_kos_toolbar-right {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 640px) {\n  .h_kos_tabs {\n    width: 100%;\n  }\n\n  .h_kos_tab {\n    padding: 7px 12px;\n  }\n\n  .h_kos_period-btn {\n    padding: 6px 10px;\n  }\n\n  .h_kos_date-popup {\n    right: auto;\n    left: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .h_kos_title {\n    font-size: 16px;\n  }\n\n  .h_kos_subtitle {\n    max-width: 100%;\n  }\n\n  .h_kos_header-actions {\n    gap: 6px;\n  }\n\n  .h_kos_date-btn {\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
